export const styles = {
  // Main container
  container: {
    padding: '20px',
    maxWidth: '1200px',
    margin: '0 auto'
  },

  // PolicyHeader styles
  header: {
    marginBottom: '30px'
  },
  headerTitle: {
    fontSize: '24px',
    fontWeight: 'bold',
    marginBottom: '10px'
  },
  headerInfo: {
    display: 'flex',
    gap: '20px',
    alignItems: 'center'
  },
  headerText: {
    color: '#666',
    fontSize: '16px'
  },
  headerStatus: {
    fontSize: '16px',
    fontWeight: '500'
  },

  // AmendmentTypeGrid styles
  gridTitle: {
    fontSize: '20px',
    fontWeight: 'bold',
    marginBottom: '20px'
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
    gap: '15px'
  },

  // AmendmentTypeCard styles
  card: {
    backgroundColor: 'white',
    border: '1px solid #ddd',
    borderRadius: '8px',
    padding: '15px',
    cursor: 'pointer',
    transition: 'all 0.2s',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
  },
  cardIcon: {
    fontSize: '24px',
    marginBottom: '8px'
  },
  cardTitle: {
    fontSize: '14px',
    fontWeight: 'bold',
    marginBottom: '6px'
  },
  cardDescription: {
    fontSize: '12px',
    color: '#666',
    lineHeight: '1.4'
  },

  // LoadingState styles
  loadingContainer: {
    padding: '20px',
    textAlign: 'center'
  },

  // ErrorState styles
  errorContainer: {
    padding: '20px',
    textAlign: 'center'
  },
  errorBox: {
    backgroundColor: '#f8d7da',
    border: '1px solid #f5c6cb',
    borderRadius: '4px',
    padding: '20px',
    maxWidth: '600px',
    margin: '0 auto'
  },
  errorTitle: {
    color: '#721c24',
    marginBottom: '10px'
  },
  errorMessage: {
    color: '#721c24',
    marginBottom: '15px'
  },
  errorButton: {
    backgroundColor: '#dc3545',
    color: 'white',
    border: 'none',
    borderRadius: '4px',
    padding: '10px 20px',
    cursor: 'pointer',
    fontSize: '14px'
  }
};
